// ---------------------------------------------------------------
// PERSISTENCE
// - cookies cannot handle more than 4096 bytes!
// - cookie and expiration with minimum footprint
//   cf. https://github.com/js-cookie/js-cookie/wiki/Frequently-Asked-Questions
// - using gmapsStore here would make some functions disappear in the cached version
// - avoid localstorage: no expiration
// ---------------------------------------------------------------
import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
// import Cookies from 'js-cookie'
// import createPersistedState from 'vuex-persistedstate'

import appStore from './modules/appStore';
import adminStore from './modules/adminStore';
import audioStore from './modules/audioStore';
import bankStore from './modules/bankStore';
import billingStore from './modules/billingStore';
import calendarsStore from './modules/calendarsStore';
import chatStore from './modules/chatStore';
import commsStore from './modules/commsStore';
import companiesStore from './modules/companiesStore';
import contentStore from './modules/contentStore';
import debugStore from './modules/debugStore';
import eventStore from './modules/eventStore';
import financeStore from './modules/financeStore';
import gmapsStore from './modules/gmapsStore';
import habitatStore from './modules/habitatStore';
import supportStore from './modules/supportStore';
import marketplaceStore from './modules/marketplaceStore';
import modulesStore from './modules/modulesStore';
import patientsStore from './modules/patientsStore';
import productsStore from './modules/productsStore';
import ratingStore from './modules/ratingStore';
import receiverStore from './modules/receiverStore';
import resultStore from './modules/resultStore';
import saasStore from './modules/saasStore';
import spaceStore from './modules/spaceStore';
import settingsStore from './modules/settingsStore';
import subscriptionsStore from './modules/subscriptionsStore';
import supplierStore from './modules/supplierStore';
import surveyStore from './modules/surveyStore';
import teamStore from './modules/teamStore';
import termsOfUseStore from './modules/termsOfUseStore';
import timeslotStore from './modules/timeslotStore';
import userStore from './modules/userStore';
import validateUserStore from './modules/validateUserStore';
import validateCompanyStore from './modules/validateCompanyStore';
import virtualSecretaryStore from './modules/virtualSecretaryStore';

Vue.use(Vuex);

// const isDev = process.env.NODE_ENV ? process.env.NODE_ENV === 'development' : true

// 1/12 of a day, or 2 hours
// const cookieParams = { sameSite: 'lax', expires: 1 / 12, secure: !isDev }
// const persistPluginCookie = createPersistedState({
//   key: '__habitat_cache_cookie',
//   paths: ['user.name'],
//   storage: {
//     getItem: key => Cookies.get(key),
//     setItem: (key, value) => Cookies.set(key, value, cookieParams),
//     removeItem: key => Cookies.remove(key, cookieParams), // cookieParams are needed for removal
//   }
// })

// const persistPluginSessionStorage = createPersistedState({
//   storage: window.sessionStorage,
//   key: '__habitat_cache_session',
//   paths: [
//     'specialization.specializations',
//     'language.allLanguages',
//     'healthplan.allHealthplans',
//   ],
// })

// import SecureLS from 'secure-ls'
// const ls = new SecureLS({ isCompression: true })
// const persistPluginEncryptedSessionStorage = createPersistedState({
//   key: '__habitat_cache_encrypted_ls',
//   paths: ['specialization.specializations'],
//   storage: {
//     getItem: (key) => ls.get(key),
//     setItem: (key, value) => ls.set(key, value),
//     removeItem: (key) => ls.remove(key),
//   },
// })

export default new Vuex.Store({
  modules: {
    app: appStore,
    audio: audioStore,
    admin: adminStore,
    bank: bankStore,
    billing: billingStore,
    calendars: calendarsStore,
    chat: chatStore,
    comms: commsStore,
    companies: companiesStore,
    contents: contentStore,
    debug: debugStore,
    event: eventStore,
    finance: financeStore,
    habitat: habitatStore,
    gmaps: gmapsStore,
    support: supportStore,
    marketplace: marketplaceStore,
    modules: modulesStore,
    patients: patientsStore,
    products: productsStore,
    ratings: ratingStore,
    receiver: receiverStore,
    result: resultStore,
    saas: saasStore,
    space: spaceStore,
    settings: settingsStore,
    subscription: subscriptionsStore,
    surveys: surveyStore,
    supplier: supplierStore,
    team: teamStore,
    termsOfUse: termsOfUseStore,
    timeslot: timeslotStore,
    user: userStore,
    validateUser: validateUserStore,
    validateCompany: validateCompanyStore,
    virtualSecretary: virtualSecretaryStore,
  },
  plugins: [
    // persistPluginCookie,
    // persistPluginSessionStorage
    new VuexPersistence({
      modules: ['team'],
    }).plugin
  ],
})
